// ProtectedRoute.js: Restrict access to authenticated users and roles
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRoles } from '../utils/auth';
import { useProfile } from '../context/ProfileContext';

function ProtectedRoute({ children, allowedRoles }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles) {
    // Prefer server-side profile roles when available (avoids stale localStorage issues)
    const { profile } = useProfile() || {};
    const userRoles = profile?.role ? (Array.isArray(profile.role) ? profile.role.map(r => String(r).toLowerCase()) : [String(profile.role).toLowerCase()]) : getUserRoles();
    const ok = allowedRoles.some(r => userRoles.includes(String(r).toLowerCase()));
    if (!ok) return <Navigate to="/" replace />;
  }
  return children;
}

export default ProtectedRoute;
